/**
 * client/src/components/premium/milestone-pill.tsx
 *
 * The small uppercase status chip used in the setup flow ("PASSKEY
 * REGISTERED"). Colour maps to CLAUDE.md semantics — emerald for milestones,
 * blue for informational states, amber for warnings, neutral grey otherwise.
 * Never red (red is Forensic Pause only).
 */

import type { ReactNode } from "react";

type PillTone = "emerald" | "blue" | "amber" | "neutral";

const TONE: Record<PillTone, string> = {
  // strenn-emerald design token (not raw emerald-*) — the AAL-milestone accent is
  // token-governed (DESIGN-SYSTEM.md §1; check-design-tokens gate).
  emerald: "border-strenn-emerald/30 bg-strenn-emerald/10 text-strenn-emerald",
  blue: "border-blue-500/30 bg-blue-500/10 text-blue-300",
  amber: "border-amber-500/30 bg-amber-500/10 text-amber-400",
  neutral: "border-border-default bg-bg-overlay text-text-tertiary",
};

export interface MilestonePillProps {
  children: ReactNode;
  tone?: PillTone;
  icon?: ReactNode;
  className?: string;
}

export function MilestonePill({ children, tone = "emerald", icon, className }: MilestonePillProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${TONE[tone]} ${className ?? ""}`}
    >
      {icon}
      {children}
    </span>
  );
}
